"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnboardingLicense = void 0;
const licenses_1 = require("@completeanatomy/licenses");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const router_1 = require("../router");
function useOnboardingLicense() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const user = (0, user_1.useUser)();
    const license = (0, licenses_1.useUserLicenses)();
    /**
     * On component mount, start check for b2b license
     */
    (0, react_1.useEffect)(() => {
        if (!(user === null || user === void 0 ? void 0 : user.identifier)) {
            return;
        }
        const activeBtbLicense = license === null || license === void 0 ? void 0 : license.some(s => s.isB2B && s.isActive);
        if (!activeBtbLicense) {
            navigate(`${router_1.Route.Base}/${router_1.Route.RedeemCode}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user === null || user === void 0 ? void 0 : user.identifier, license]);
}
exports.useOnboardingLicense = useOnboardingLicense;
